import { usePageMeta } from "@/hooks/usePageMeta";
import Hero from "@/pages/home/components/Hero";
import CategoryQuick from "@/pages/home/components/CategoryQuick";
import HotSites from "@/pages/home/components/HotSites";
import NewSites from "@/pages/home/components/NewSites";
import BrandIntro from "@/pages/home/components/BrandIntro";

export default function Home() {
  usePageMeta({
    title: "网址导航-快速访问热门网站的入口",
    description:
      "网址导航为用户提供最新最全的热门网站分类，帮助快速找到实用资源和常用平台，方便高效上网体验。",
    keywords: "网址导航,网站入口,网站导航,热门网站,快速访问,实用网站,网络导航,网站分类",
  });

  return (
    <>
      <Hero />
      <CategoryQuick />
      <HotSites />
      <NewSites />
      <BrandIntro />
    </>
  );
}